import React, {Component} from 'react'
import UpdateBatchesPageNew from "./UpdateBatchesPageNew"
import UpdateBatchesPage from "./UpdateBatchesPage"
import '../styles/index.scss'

class UpdateBatchesContainer extends Component {
    render() {
        return (
            <div className="UpdateBatchesContainer p-5">
                <div className='row'>
                    <div className='col-12 mx-auto'>
                        <div className="d-flex align-items-baseline justify-content-between">
                            <h1 className="PageTitle">Cập nhật trạng thái lô</h1>
                        </div>
                        <div className="site-layout-background">
                            {/* <UpdateBatchesPage/> */}
                            <UpdateBatchesPageNew/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default UpdateBatchesContainer